"use client";
import helpIcon from "@/assets/images/icon/help-icon.svg";
import vibgorone from "@/assets/images/logo/VIBGYORONE_LOGO.jpg";
import Olymmpia from "@/assets/images/logo/Olympialogo.png";
import add_to_cart_with_white_background from "@/assets/images/logo/add_to_cart_with_white_background.svg";
import logo_1 from "@/assets/images/logo/logo_01.svg";
import { MdAdminPanelSettings } from "react-icons/md";
import UserDetails from "@/components/userDetails";
import UseSticky from "@/hooks/UseSticky";
import { logout } from "@/redux/features/authSlice";
import { clearCart, selectCartItems } from "@/redux/features/cartSlice";
import axiosInstance from "@/service/axiosInstance";
import { APP_NAME, ENV, HttpMethod, ORDER_TYPE } from "@/utils/enum";
import { Badge } from "antd";
import Image from "next/image";
import Link from "next/link";
import { usePathname, useRouter } from "next/navigation";
import { ChangeEvent, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import NavMenu from "./Menu/NavMenu";
// import { useSession, signIn, signOut } from "next-auth/react";
import Loader from "@/components/Loader/Loader";
import { jwtDecode } from "jwt-decode";
import { signOut, useSession } from "next-auth/react";
import { FaListOl, FaPhoneAlt, FaSignOutAlt, FaUser } from "react-icons/fa";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { selectVivaCartItems } from "@/redux/features/vivaCartSlice";
import dynamic from "next/dynamic";
import {
  addFilter,
  clearFilter,
  filterItems,
} from "@/redux/features/filterSlice";
import { useSearchParams } from "next/navigation";
import { Search } from "lucide-react";
import { clearUserData } from "@/redux/features/userDataSlice";
import { clearPsaData } from "@/redux/features/psaFilterSlice";
import { clearVafpData } from "@/redux/features/vafpFilterSlice";
import { clearGiData } from "@/redux/features/giFilterSlice";
import { clearSummerCampData } from "@/redux/features/summerCampSlice";

dayjs.extend(customParseFormat);

const LoginModal = dynamic(() => import("@/modals/LoginModal"), { ssr: false });
const HelpModal = dynamic(
  () => import("@/components/header/help-icon-modal/page"),
  { ssr: false },
);

const HeaderOne = ({ style }: any) => {
  const { data: session, status }: any = useSession();
  console.log("🚀 ~ index ~ session:", session);
  let Vivacart = useSelector(selectVivaCartItems);
  let cart = useSelector(selectCartItems);
  const filter = useSelector(filterItems);

  const [isHovered, setIsHovered] = useState(false);
  const [helpModal, setHelpModal] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const dispatch = useDispatch();
  //const userRoleVal = useSelector((state: any) => state.auth.userRole);
  // const swapData = useSelector((state: any) => state.swapData.data);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [role, setRole] = useState(null);
  const [userDetailsModal, setUserDetailsModal] = useState(false);
  const [userName, setUserName] = useState("");
  const [token, setToken] = useState<string | null>(null);
  const [toogleLive, setToogleLive] = useState(false);
  const pathname = usePathname();
  const userRoleVal = useSelector((state: any) => state.auth.userRole);
  const router = useRouter();
  const [isMobile, setIsMobile] = useState(false);
  const isAuthenticated = useSelector(
    (state: any) => state.auth.isAuthenticated,
  );

  const app_name = process.env.NEXT_PUBLIC_APP_NAME;
  switch (process.env.NEXT_PUBLIC_APP_NAME) {
    case APP_NAME.VIBGYOR_VIVA:
      cart = cart.filter((tempCart: any) => {
        if (!tempCart || !tempCart.attributes) return false;
        return tempCart.attributes.web_name !== "Summer Camp";
      });
      break;

    case APP_NAME.VIBGYOR_ONE:
      // cart = cart.filter((tempCart: any) => {
      //   if (!tempCart || !tempCart.attributes) return false;
      //   return tempCart.attributes.web_name === "Summer Camp";
      // });
      break;
    default:
      break;
  }

  useEffect(() => {
    // This useEffect is used for old users that are accessing the website after a long time. It Resets the local storge and auth in persist to solve client side application error
    const today = dayjs();
    try {
      const currentYear = today.year();
      const aprilFirst = dayjs(`${currentYear}-04-01`);

      const aprilResetYear = localStorage.getItem("aprilResetYear");
      const isAprilResetDone = aprilResetYear === String(currentYear);

      const storedDateStr = localStorage.getItem("appVersionDate");
      const storedDate = dayjs(storedDateStr, "DDMMYYYY");
      const diffDays = today.diff(storedDate, "days");

      if (!storedDate.isValid() || diffDays > 1) {
        // Runs only once per year after April 1st
        if (!isAprilResetDone && !today.isBefore(aprilFirst, "day")) {
          dispatch(clearUserData());
          dispatch(clearPsaData());
          dispatch(clearVafpData());
          dispatch(clearGiData());
          dispatch(clearSummerCampData());

          localStorage.setItem("aprilResetYear", String(currentYear));
        }
        // Normal 7-day logic
        else if (diffDays > 7) {
          dispatch(clearUserData());
          dispatch(clearPsaData());
          dispatch(clearVafpData());
          dispatch(clearGiData());
          dispatch(clearSummerCampData());
        }

        dispatch(logout());
        localStorage.clear();
        sessionStorage.clear();

        localStorage.setItem("appVersionDate", today.format("DDMMYYYY"));
        localStorage.setItem("aprilResetYear", String(currentYear));
      }
    } catch (err) {
      console.warn("Storage reset due to error:", err);
      dispatch(logout());
      localStorage.clear();
      sessionStorage.clear();
      localStorage.setItem("appVersionDate", today.format("DDMMYYYY"));
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (typeof window !== "undefined") {
        const storedToken = localStorage.getItem("token");
        console.log("🚀 ~ fetchData ~ storedToken:", storedToken);
        setToken(storedToken);

        if (storedToken) {
          try {
            const decodedToken: any = jwtDecode(storedToken);
            const public_token = process.env.NEXT_PUBLIC_API_TOKEN;
            const { data } = await axiosInstance.get(
              `/user/${decodedToken.phone_number}`,
              {
                headers: {
                  "x-api-token": `Bearer ${public_token}`,
                },
              },
            );
            setUserName(data.Firstname + " " + data.Lastname);
            setPhoneNumber(decodedToken.phone_number);
            setRole(decodedToken.role);
          } catch (error) {
            console.error("Error decoding token or fetching data:", error);
          }
        }
      }
    };

    fetchData();
  }, [isAuthenticated]);

  const totalItemsInCart = cart.reduce((total, item) => total + item.inCart, 0);
  const totalVivaItemsInCart = Vivacart.reduce(
    (total, item) => total + item.inCart,
    0,
  );
  let cartLink = "/cart";
  if (totalVivaItemsInCart) {
    cartLink = "/cart";
  } else if (totalItemsInCart) {
    cartLink = "/cart";
  }

  const { sticky } = UseSticky();
  // const [cart] = Usecart

  async function keycloakSessionLogOut() {
    try {
      await fetch(`/api/auth/logout`, { method: HttpMethod.GET });
    } catch (err) {
      console.error(err);
    }
  }

  const handleModalClose = () => {
    setHelpModal(false);
  };

  const handleGroupNameSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    dispatch(
      addFilter({ ...filter, eventSearchBox: e.target.value, currentPage: 1 }),
    );
  };

  const handleSearchClick = () => {
    router.push("/events");
  };

  const handleSearchKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSearchClick();
    }
  };

  const checkForLiveEvents = async () => {
    try {
      const data: any = await axiosInstance.get("events/live-check");

      if (data?.response?.status == 400) {
        throw new Error(
          data?.response?.data?.message || "Something went wrong",
        );
      }

      if (data?.data) {
        setToogleLive(true);
      } else {
        if (toogleLive) {
          setToogleLive(false);
        }
      }
    } catch (error: any) {
      setToogleLive(false);
      console.log(
        JSON.stringify({
          page: "live",
          message: "Error in checkForLiveEvents method",
          error: error.message || error,
        }),
      );
    }
  };

  useEffect(() => {
    if (
      status != "loading" &&
      session &&
      session?.error === "RefreshAccessTokenError"
    ) {
      signOut({ callbackUrl: "/" });
    }
  }, [session, status]);

  useEffect(() => {
    checkForLiveEvents();

    const mediaQuery = window.matchMedia("(max-width: 768px)");
    setIsMobile(mediaQuery.matches);
  }, [pathname]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      setToken(localStorage.getItem("token"));
    }
  }, [token]);

  console.log("🚀 ~ HeaderOne ~ isAuthenticated:", isAuthenticated);

  if (status == "loading") {
    return (
      <div className="my-3">
        <Loader />
      </div>
    );
  }

  const getLogo = () => {
    switch (app_name) {
      case APP_NAME.VIBGYOR_VIVA:
        return logo_1;

      case APP_NAME.VIBGYOR_ONE:
        return vibgorone;
      case APP_NAME.SUMMER_CAMP_PRIVATE:
        return Olymmpia;
      default:
        return logo_1;
    }
  };

  return (
    <>
      <HelpModal show={helpModal} handleClose={handleModalClose} />
      <header
        className={`theme-main-menu menu-style-one sticky-menu shadow-sm fixed`}
        style={{ zIndex: 1100 }}
      >
        {/* {[ENV.DEV, ENV.UAT].includes(app_env) && (
          <div className="d-flex bg-warning p-2 justify-content-center">
            Deployed using common code base {app_name}
          </div>
        )} */}
        <div className="inner-content gap-one mb-1">
          <div className="top-header position-relative">
            <div
              className="d-flex gap-2"
              style={{ justifyContent: "space-between" }}
            >
              <div
                className="logo order-lg-0 d-flex align-items-center justify-content-start"
                style={{ maxWidth: "25%" }}
              >
                <Link href="/" className="d-flex align-items-center ">
                  <Image
                    src={getLogo()}
                    alt="Homepage logo"
                    priority={true}
                    style={{
                      maxHeight: "66px",
                      width: "auto",
                      objectFit: "contain",
                    }}
                    className={isMobile ? "w-90" : ""}
                  />
                </Link>
              </div>
              {app_name == APP_NAME.VIBGYOR_VIVA && (
                <div className="d-none d-xl-flex align-items-center justify-content-start flex-grow-1">
                  <div className=" rainbow-border w-100 position-relative">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search for events e.g. Swimming, Dancing..."
                      value={filter?.eventSearchBox || ""}
                      onChange={handleGroupNameSearchChange}
                      onKeyDown={handleSearchKeyDown}
                      style={{
                        borderRadius: "0.5rem",
                        fontSize: "1rem",
                        padding: "0.5rem 0.75rem",
                      }}
                    />
                    <Search
                      className="position-absolute top-50 end-0 translate-middle bg-white cursor-pointer"
                      onClick={handleSearchClick}
                    />
                  </div>
                </div>
              )}
              <div className="d-flex align-items-center justify-content-start gap-3 flex-row-reverse">
                <nav className="navbar navbar-expand-lg order-lg-2">
                  <button
                    className={`navbar-toggler d-block d-lg-none ${
                      expanded ? "expanded" : ""
                    }`}
                    type="button"
                    aria-label="Toggle navigation"
                    onClick={() => {
                      const navbarCollapse =
                        document.getElementById("navbarNav");
                      if (navbarCollapse) {
                        navbarCollapse.classList.toggle("show");
                      }
                      setExpanded(!expanded);
                    }}
                  >
                    <span
                      className="navbar-toggler-icon"
                      style={{ maxWidth: "40px" }}
                    ></span>
                  </button>
                  <div className="collapse navbar-collapse" id="navbarNav">
                    <NavMenu
                      setExpanded={setExpanded}
                      toogleLive={toogleLive}
                      pathname={pathname}
                      isExpanded={expanded}
                    />

                    {/* Following will be displayed in side menu in mobile */}
                    {(isAuthenticated || session) && (
                      <div className="desktop-hide navbar-nav border-top">
                        <div className="nav-item">
                          <div className="nav-link d-block">
                            <span className="rounded-circle pr-10pr">
                              <FaUser className="custom-user-icon" />
                            </span>
                            {session ? session?.user?.name : userName}
                          </div>
                        </div>
                        <div className="nav-item">
                          <div className="nav-link d-block">
                            <span className="rounded-circle pr-10pr">
                              <FaPhoneAlt className="custom-user-icon" />
                            </span>
                            {phoneNumber ? phoneNumber : "- -"}
                          </div>
                        </div>
                        <div className="nav-item">
                          <div className="nav-link d-block">
                            <span className="rounded-circle pr-10pr">
                              <MdAdminPanelSettings className="custom-user-icon" />
                            </span>
                            {role || "- -"}
                          </div>
                        </div>
                        <div className="nav-item">
                          <Link
                            href="/orderhistory"
                            className="dropdown-item"
                            onClick={() => {
                              const navbarCollapse =
                                document.getElementById("navbarNav");
                              if (navbarCollapse)
                                navbarCollapse.classList.toggle("show");
                              setExpanded(!expanded);
                            }}
                          >
                            <div className="nav-link d-block">
                              <span className="rounded-circle pr-10pr">
                                <FaListOl className="custom-user-icon" />
                              </span>
                              {"My Activities"}
                            </div>
                          </Link>
                        </div>
                        <div className="nav-item">
                          <div className="nav-link d-block">
                            <button
                              className="text-danger"
                              onClick={() => {
                                if (session) {
                                  keycloakSessionLogOut().then(() =>
                                    signOut({ callbackUrl: "/" }),
                                  );
                                  localStorage.removeItem("summerCampFormData");
                                  localStorage.removeItem(
                                    "summerCampSearchForm",
                                  );
                                  dispatch(clearCart());
                                } else {
                                  localStorage.removeItem("token");
                                  localStorage.removeItem("summerCampFormData");
                                  localStorage.removeItem(
                                    "summerCampSearchForm",
                                  );
                                  dispatch(clearCart());
                                  dispatch(logout());
                                  setToken(null);
                                }
                              }}
                            >
                              <span className="rounded-circle pr-10pr">
                                <FaSignOutAlt />
                              </span>
                              Logout
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  {/* following displays a see through backdrop to block clicking on page behind menu */}
                  <div
                    className={`collapse navbar-collapse-backdrop ${
                      expanded ? "show" : ""
                    }`}
                    onClick={() => {
                      const navbarCollapse =
                        document.getElementById("navbarNav");
                      if (navbarCollapse)
                        navbarCollapse.classList.toggle("show");
                      setExpanded(!expanded);
                    }}
                  ></div>
                </nav>
                {/* align-items-center */}
                {!(isAuthenticated || session) && (
                  <Link
                    href="/login"
                    className="text-decoration-none navbar-text login-btn"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "5rem",
                      backgroundColor: "var(--Primary, #3F41D1)",
                      color: "var(--Full-White, #FFF)",
                      padding: "0.5rem 1.25rem",
                      // height: "47px",
                    }}
                  >
                    <span>Login</span>
                  </Link>
                )}

                {(isAuthenticated || session) && (
                  <div
                    className="mobile-hidden"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <span
                      className="d-inline-flex position-relative"
                      data-bs-toggle="tooltip"
                      // title="Profile"
                    >
                      <div
                        className="hover-container cursor-pointer header-icon"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: "50%",
                          height: "3.13rem",
                          width: "3.13rem",
                          border: "1px solid #3F41D1",
                          backgroundColor: "white",
                          position: "relative",
                        }}
                      >
                        <FaUser
                          className="custom-user-icon"
                          style={{ fontSize: "1.5rem" }}
                        />
                        <ul className="dropdown-menu profile-dropdown w-auto">
                          <li
                            className="submenu-item position-relative"
                            title="User Name"
                          >
                            <span className="dropdown-item">
                              <span className="rounded-circle pr-10pr">
                                <FaUser className="custom-user-icon" />
                              </span>
                              {session ? session?.user?.name : userName}
                            </span>
                          </li>
                          <li
                            className="submenu-item position-relative"
                            title="User Role"
                          >
                            <span className="dropdown-item">
                              <span className="rounded-circle pr-10pr">
                                <MdAdminPanelSettings className="custom-user-icon" />
                              </span>
                              {role || "User"}
                            </span>
                          </li>
                          <li
                            className="submenu-item position-relative"
                            title="Mobile Number"
                          >
                            <span className="dropdown-item">
                              <span className="rounded-circle pr-10pr">
                                <FaPhoneAlt className="custom-user-icon" />
                              </span>
                              {phoneNumber ? phoneNumber : "- -"}
                            </span>
                          </li>
                          <li
                            className="submenu-item position-relative"
                            title="My activities"
                          >
                            <Link
                              href="/orderhistory"
                              className="dropdown-item"
                            >
                              <span className="dropdown-item">
                                <span className="rounded-circle pr-10pr">
                                  <FaListOl className="custom-user-icon" />
                                </span>
                                {"My Activities"}
                              </span>
                            </Link>
                          </li>
                          <li
                            className="submenu-item position-relative"
                            title="Logout"
                          >
                            <button
                              className="dropdown-item text-danger"
                              onClick={() => {
                                if (session) {
                                  keycloakSessionLogOut().then(() =>
                                    signOut({ callbackUrl: "/" }),
                                  );
                                  localStorage.removeItem("summerCampFormData");
                                  localStorage.removeItem(
                                    "summerCampSearchForm",
                                  );
                                  dispatch(clearCart());
                                } else {
                                  localStorage.removeItem("token");
                                  localStorage.removeItem("summerCampFormData");
                                  localStorage.removeItem(
                                    "summerCampSearchForm",
                                  );
                                  dispatch(clearCart());
                                  dispatch(logout());
                                  setToken(null);
                                }
                                dispatch(clearFilter());
                              }}
                            >
                              <span className="rounded-circle pr-10pr">
                                <FaSignOutAlt />
                              </span>
                              Logout
                            </button>
                          </li>
                        </ul>
                      </div>
                    </span>
                  </div>
                )}

                {(app_name == APP_NAME.VIBGYOR_ONE ||
                  app_name == APP_NAME.SUMMER_CAMP_PRIVATE) && (
                  <>
                    {isAuthenticated || session ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          position: "relative",
                        }}
                      >
                        <Link
                          href="/cart"
                          className="header-icon"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "50%",
                            height: "3.13rem",
                            width: "3.13rem",
                            backgroundColor: "white",
                            position: "relative",
                          }}
                        >
                          <Badge
                            count={totalItemsInCart}
                            className="cursor-pointer"
                          >
                            <Image
                              src={add_to_cart_with_white_background}
                              alt="Cart"
                              className="header-icon"
                            />
                          </Badge>
                        </Link>
                        {/* <ul className="dropdown-menu cart-dropdown">
                                <li className="submenu-item position-relative">
                                  <Link
                                    href="/cart"
                                    className="dropdown-item d-flex align-items-start"
                                  >
                                    <span className="pr-10pr">
                                      <PiShoppingCartThin
                                        height={20}
                                        width={20}
                                      />
                                    </span>
                                    {"Cart "}
                                    <Badge count={totalItemsInCart}></Badge>
                                  </Link>
                                </li>
                                <li className="submenu-item position-relative">
                                  <Link
                                    href="/orderhistory"
                                    className="dropdown-item d-flex align-items-start"
                                  >
                                    <span className="pr-10pr">
                                      <PiListChecksBold
                                        height={20}
                                        width={20}
                                      />
                                    </span>
                                    {"My Activities"}
                                  </Link>
                                </li>
                              </ul> */}
                      </div>
                    ) : (
                      // viva one cart icon
                      <Link href="/cart" className="position-relative">
                        <Image
                          src={add_to_cart_with_white_background}
                          alt="cart"
                          className="header-icon"
                          // style={{
                          //   display: "flex",
                          //   alignItems: "center",
                          //   justifyContent: "center",
                          //   borderRadius: "50%",
                          // //   height: "3.13rem",
                          // //   width: "3.13rem",
                          //   backgroundColor: "white",
                          //   position: "relative",
                          // }}
                        />
                        <Badge
                          className="d-block position-absolute top-0"
                          style={{ top: "10%", right: "10%" }}
                          count={totalVivaItemsInCart || totalItemsInCart}
                        ></Badge>
                      </Link>
                    )}
                  </>
                )}

                {app_name == APP_NAME.VIBGYOR_VIVA && (
                  <div className="rounded-full d-flex flex-row gap-2 justify-content-center">
                    {/* {isAuthenticated &&
                          [USER_ROLE.VT, USER_ROLE.admin].includes(userRoleVal) &&
                          swapData && (
                            <div
                              className="d-flex"
                              onClick={() => setShowSwapActiveModal(true)}
                              style={{
                                cursor: "pointer",
                                justifyContent: "center",
                                alignItems: "center",
                                fontSize: "1.2rem",
                              }}
                            >
                              <MdOutlineSwapHorizontalCircle
                                size={56}
                                color="#0a58ca"
                              />
                            </div>
                          )} */}

                    <div
                      className="d-flex header-icon"
                      onClick={() => setHelpModal(true)}
                      style={{
                        height: "50px",
                        width: "50px",
                        cursor: "pointer",
                      }}
                    >
                      <Image
                        src={helpIcon}
                        alt="info"
                        style={{
                          height: "100%",
                          width: "100%",
                        }}
                      />
                    </div>
                    <div style={{ cursor: "pointer" }}>
                      <Link
                        href={cartLink}
                        className="d-flex justify-content-center align-items-center"
                        style={{
                          height: "100%",
                          width: "100%",
                        }}
                      >
                        <Badge count={totalVivaItemsInCart || totalItemsInCart}>
                          <Image
                            src={add_to_cart_with_white_background}
                            alt="cart-item-count"
                            className="header-icon"
                          />
                        </Badge>
                      </Link>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="d-flex d-xl-none align-items-center justify-content-start flex-grow-1 mt-4">
            {app_name == APP_NAME.VIBGYOR_VIVA && (
              <div className=" rainbow-border w-100 position-relative">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search for events e.g. Swimming, Dancing..."
                  value={filter?.eventSearchBox || ""}
                  onChange={handleGroupNameSearchChange}
                  onKeyDown={handleSearchKeyDown}
                  style={{
                    borderRadius: "0.5rem",
                    fontSize: "1rem",
                    padding: "0.5rem 0.75rem",
                  }}
                />
                <Search
                  className="position-absolute top-50 end-0 translate-middle bg-white cursor-pointer"
                  onClick={handleSearchClick}
                />
              </div>
            )}
          </div>
        </div>
      </header>
      <LoginModal />
      <style>{`
      .custom-user-icon {
        color: #3F41D1;
      }

      .custom-user-icon svg {
        fill: white;
        stroke: #3F41D1;
        stroke-width: 1;
      }

      .profile-dropdown, .cart-dropdown {
          position: absolute;
          top: 101%;
          right: 0;
          // width: 150px;
          background: white;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
          z-index: 1000;
          border-radius: 6px;
          padding: 0;
          margin: 0;
          display: none;
          border: none;
    outline: none;
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
  }

  .hover-container:hover .profile-dropdown,
  .hover-container:hover .cart-dropdown {
    display: block;
    visibility: visible;
    opacity: 1;
  }

      .submenu-item {
        padding: 10px 15px;
        list-style: none;
      }

      .dropdown-item {
        color: inherit;
        display: block;
        padding: 0 0.25rem;
        width: 100%;
        text-decoration: none;
      }

  .submenu-item button.dropdown-item {
    color: #3F41D1;
    cursor: pointer;
  }

  .nav-link-wrapper:hover {
    visibility: visible;
    opacity: 1;
  }

  .nav-link {
    display: inline-block;
  }

  .dropdown-item:hover {
  color: #3F41D1;
}
  /* Cart icon sizing */
    .header-icon {
      object-fit: contain;
      width: 50px;
      height: 50px;
      min-width: 50px;
      min-height: 50px;
      max-width: 50px;
      max-height: 50px;
    }
    .login-btn {
        height: 50px !important;
    }


    @media (max-width: 1553px) {
      .header-icon {
        object-fit: contain;
        width: 35px;
        height: 35px;
        min-width: 35px;
        min-height: 35px;
        max-width: 35px;
        max-height: 35px;
      }
        
      .login-btn {
          height: 35px !important;
      }

    }

    @media (max-width: 991px) {
      .header-icon {
        object-fit: contain;
        width: 40px;
        height: 40px;
        min-width: 40px;
        min-height: 40px;
        max-width: 40px;
        max-height: 40px;
      }
      .login-btn {
        height : 40px !important
      }
    }
`}</style>
      <UserDetails
        userDetailsModal={userDetailsModal}
        setUserDetailsModal={setUserDetailsModal}
        phoneNumber={phoneNumber}
      />
    </>
  );
};

export default HeaderOne;
